import React from 'react';

import {publicAssetUrl} from '../../../config';
import {
  Preview,
  PreviewHint,
  PreviewImage,
  PreviewSubtitle,
  PreviewTitle,
} from './ReportPreview.styles';

type ReportPreviewProps = {
  entityName: string;
  projectName: string;
  small?: boolean;
  accountSelector?: boolean;
  onClick?: () => void;
};

export const ReportPreview: React.FC<ReportPreviewProps> = React.memo(
  ({entityName, projectName, small, accountSelector, onClick}) => {
    return (
      <Preview
        id="report-preview"
        small={small}
        accountSelector={accountSelector}
        onClick={onClick}>
        <PreviewTitle>This week's findings</PreviewTitle>
        <PreviewSubtitle>
          {entityName}/{projectName}
        </PreviewSubtitle>
        <PreviewImage src={publicAssetUrl('/report-preview-charts.png')} />
        <PreviewHint>Add description...</PreviewHint>
      </Preview>
    );
  }
);
